export const Currency = {
  USD: '$',
  GBP: '£',
  EUR: '€',
  INR: '₹',
  CAD: '$',
} as const;
